<script>
    export let value;
    export let id = '';
    export let placeholder = '';
    export let required = false;
    export let disabled = false;
</script>

<input type="text" class="form-control" id="{ id }" bind:value="{ value }"
       oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
       {placeholder}
       {required}
       {disabled}
/>
